import { LanguageId } from 'src/common/constants/LanguageId';

export interface CollapseStateMap {
  [databaseName: string]: boolean;
}

export interface StoredQueryTags {
  /** tags and questions as retrieved from the platform (may not contain all
   * tags that should be displayed, such as Voicebox Query Prompt) **/
  userTags: Set<string>;
  voiceboxQuestions?: string[];
}

export interface StoredQuery {
  name: string;
  creator: string;
  database: string;
  query: string;
  shared: boolean;
  // Was added in version 6.2.2
  reasoning?: boolean;
  // GraphQL stored queries were added in 6.2.3
  languageId?: LanguageId;
  // Voicebox tags added in 10.0.0
  tags: StoredQueryTags;
}

export interface StoredQueryMap {
  [databaseName: string]: StoredQuery[];
}

export class StoredQueryState {
  public isCached = false;

  public queries: StoredQuery[] = [];

  // public collapseState: CollapseStateMap = {};
}
